import styled from 'styled-components'

export const Title = styled("div")`
  font-size: 65px;
  text-align: center;
  color: var(--text);
  font-family: var(--thin);
  margin-top: 30px;
`;
